// TNL: Price Slider (43688 and 43696)
export const shouldShowPriceSlider = (min: number, max: number): boolean =>
  min !== null && min !== undefined && max !== null && max !== undefined;
